module.exports = __webpack_public_path__ + "img/chanping1.60e61821.png";